<div class="aspect-auto flex h-screen w-screen">
    <div class="left-section flex-1 items-center">
        <div class="left-section-content">
            <div class="header text-4xl">
                {{"Create your account" | textCase}}
            </div>
            <div class="my-3">
                <div class="p-fluid ">
                    <div class="p-field">
                        <div class="flex flex-col  gap-2">
                            <label class="font-medium text-sm">{{"Enter the" | textCase}} {{"OTP" |
                                textCase:CASE_TYPE.UPPER}} {{"sent on your Email " |
                                textCase:CASE_TYPE.LOWER}} {{'ID' | textCase:CASE_TYPE.UPPER}}</label>
                            <p-inputOtp [integerOnly]="true" [length]="6" style="width: 60%;"
                                (onChange)="otpInput($event)" [(ngModel)]="otpValue" />
                        </div>
                    </div>
                    <div class="flex flex-col mt-4 gap-2 w-full">
                        <app-button variant="filled" severity="primary" (clicked)="onSubmit()"
                            label="{{'Continue' | textCase}}" [disabled]="!enableSend" />

                        <app-button class="resend-otp" variant="outlined" severity="primary" [disabled]="timer !== 0"
                            (clicked)="resendOTP()"
                            [label]="('Resend' | textCase) + ' ' + ('OTP' | textCase:CASE_TYPE.UPPER) + ' ' + (timer !== 0 ? '(' + timer + ' sec)' : '')" />
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="right-section">
        <!-- <div class="login-right-section">
            <div class="header text-center">
                <span class="theme-text">
                    A completely new way to
                    <br>
                    handle your legal documents
                </span>
            </div>
        </div> -->
        <img class="login-image" [src]="'images/login-page.png' | assetUrl" [attr.alt]="'login-image' | textCase">
    </div>
</div>
